import React from "react";

export default function Loader() {
  return <div className="mx-auto spinner-border text-success" role="status">
    <span className="sr-only">Loading...</span>
  </div>;
}
